import { render } from "./HomeNewArriwals.vue?vue&type=template&id=305c0264"
import script from "./HomeNewArriwals.vue?vue&type=script&lang=js"
export * from "./HomeNewArriwals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__